// extracted by mini-css-extract-plugin
export default {"noDataNotice":"CapillaryPressurePanel_noDataNotice__RHn1S","radioGroup":"CapillaryPressurePanel_radioGroup__wL9Uz"};